module.exports = __webpack_public_path__ + "img/greezzuk.a8d58cd6.svg";